<template>
  <v-content class="projects mb-16">
    <h1
      :class="this.$vuetify.breakpoint.smAndDown ? 'mt-8' : 'mt-16'"
      class="mb-8 font-weight-thin d-flex justify-center"
    >
      Projects
    </h1>
    <Project
      v-for="project in projects"
      :key="project.id"
      :project="project"
      class="mb-6"
    ></Project>
  </v-content>
</template>
<script>
import Project from "@/components/Project.vue";

export default {
  name: "Projects",
  components: {
    Project,
  },
  data: () => ({
    projects: [
      {
        id: 0,
        title: "Web sites Japan Info Jobs",
        img: "japan_info",
        lazy: "japan_info_lazy",
        description:
          "Web sites for the company Japan Info. Those are 'Indeed.com' like applications where companies can put their offers and where candidates can apply for them. Developed in JavaScript using the framework Vue.js along with Cloud Firestore database.",
        links: [
          {
            name: "Japan info candidate",
            url: "https://japaninfojobs.netlify.com/",
          },
          {
            name: "Japan info company",
            url: "https://japaninfoclients.netlify.com/",
          },
        ],
        color: "#1F7087",
      },
      {
        id: 1,
        title: "Portfolio",
        img: "portfolio",
        lazy: "portfolio_lazy",
        description:
          "I have been developing this web application you are currently browsing. Thanks to this portal, I can share a bit of my world with you. Not only, it is a good way for me to keep track of my objectives. My portfolio is coded in Javascript and I use Vue.js framework with the library Vuetify for a better user experience.",
        links: [
          {
            name: "Portfolio Joseph Perrin",
            url: "/",
          },
        ],
        color: "#e3655b",
      },
      {
        id: 2,
        title: "Trading Bots",
        img: "bot_metatrader4",
        lazy: "bot_metatrader4_lazy",
        description:
          "Developed trading bots on the platform MetaTrader 4 to be able to automatically trade on the Foreign Exchange Market (FOREX). Coupled to a Raspberry Pi with an emulator x86 (ExaGear) to run in all day long",
        links: [
          {
            name: "Sample of source code",
            url: "ressources/brain.mql4",
          },
        ],
        color: "#122c34",
      },
      {
        id: 3,
        title: "Enigma",
        img: "enigma_invert",
        lazy: "enigma_invert_lazy",
        description:
          "Because I do not want to limit my personal projects to the IT field, one of my other projects has been the creation of a clothing concept called 'Enigma'. Check the link under the logo to see some examples.",
        links: [
          {
            name: "Examples of concepts",
            url: "ressources/enigma_clothing.png",
          },
        ],
        color: "#1F7087",
      },
    ],
  }),
};
</script>
